import { img, thumbImg } from "@/lib/images";

const f = (num: string, caption: string, captionEn: string) => ({
  key: `villas/villa-frangipani/villa-frangipani-view-${num}.jpg`,
  thumb: thumbImg(`villas/villa-frangipani/villa-frangipani-view-${num}.jpg`),
  full: img(`villas/villa-frangipani/villa-frangipani-view-${num}.jpg`),
  caption,
  captionEn,
});

export const frangipaniGalleryImages = [
  f("01", "Villa Frangipani - Schlafzimmer 1", "Villa Frangipani - Bedroom 1"),
  f("02", "Villa Frangipani - Terrasse", "Villa Frangipani - Terrace"),
  f("03", "Villa Frangipani - Terrasse", "Villa Frangipani - Terrace"),
  f("04", "Villa Frangipani - Badezimmer", "Villa Frangipani - Bathroom"),
  f("05", "Villa Frangipani - Schlafzimmer 2", "Villa Frangipani - Bedroom 2"),
  f("06", "Villa Frangipani - Badezimmer", "Villa Frangipani - Bathroom"),
  f("07", "Villa Kompiang - Pool", "Villa Kompiang - Pool"),
];